import {jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment} from "react/jsx-runtime";import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import useDocumentTitle from '../hooks/useDocumentTitle'
import useRouter from '../hooks/useRouter'
import hasToken from '../utils/hasToken'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import FlatPrimaryButton from './FlatPrimaryButton'
import InvitationDialogCopy from './InvitationDialogCopy'
import InviteDialog from './InviteDialog'





const TeamName = styled('span')({
  fontWeight: 600,
  whiteSpace: 'nowrap'
})

const DialogActions = styled('div')({
  marginTop: 20,
  display: 'flex',
  justifyContent: 'center'
})

const InvitationLinkErrorExpired = (props) => {
  const {massInvitation: massInvitationRef} = props
  const massInvitation = useFragment(
    graphql`
      fragment InvitationLinkErrorExpired_massInvitation on MassInvitationPayload {
        teamName
        teamId
      }
    `,
    massInvitationRef
  )
  const {teamName} = massInvitation
  useDocumentTitle(`Token Expired | Invitation Link`, 'Invitation Link')

  const {history} = useRouter()

  return (
    _jsxs(InviteDialog, { children: [
      _jsx(DialogTitle, { children: "Invitation Link Expired"  })
      , _jsxs(DialogContent, { children: [
        _jsxs(InvitationDialogCopy, { children: ["The invitation to "
             , _jsx(TeamName, { children: teamName}), " has expired."
        ]})
        , _jsx(InvitationDialogCopy, { children: "Reach out to the team administrator to request a new invitation"

        })
        , _jsx(DialogActions, { children: 
          hasToken() ? (
            _jsx(_Fragment, { children: 
              _jsx(FlatPrimaryButton, { onClick: () => history.push('/meetings'), size: "medium", children: "Go to Dashboard"

              })
            })
          ) : (
            _jsx(FlatPrimaryButton, { onClick: () => history.push('/'), size: "medium", children: "Sign In"

            })
          )
        })
      ]})
    ]})
  )
}

export default InvitationLinkErrorExpired
